import React from 'react';
import styled from 'styled-components';
import { colors } from '../../../assets/styles/GlobalStyles';

// Rádio buttons para escolher onde o usuário recebe correspondência.
// Regra de negócio: residencial é obrigatório; comercial é opcional, mas se
// residencial já for "Sim" o comercial é forçado para "Não" (não faz sentido
// receber correspondência em dois endereços ao mesmo tempo). O e-mail comercial
// só é obrigatório quando a correspondência comercial é escolhida.

const RadioGroup = styled.div`
  display: flex;
  gap: 1.5rem;
  margin: 0.5rem 0 1rem 0;
`;

const RadioLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.95rem;
  color: #333;
  cursor: pointer;
`;

const RadioInput = styled.input`
  margin: 0;
  width: 18px;
  height: 18px;
  cursor: pointer;
`;

/**
 * @param {string} props.type - Tipo do endereço ('residencial' ou 'comercial')
 * @param {Object} props.values - Valores do formulário
 * @param {Object} props.names - Mapeamento de nomes dos campos (FIELD_NAMES)
 * @param {Function} props.onCorrespondenciaChange - Callback ao mudar a escolha
 * @param {boolean} props.isResidencialCorrespondenceSelected - Se residencial já é "Sim"
 */
export const CorrespondenceSection = ({
  type,
  values,
  names,
  onCorrespondenciaChange,
  isResidencialCorrespondenceSelected
}) => {
  // Busca o email diretamente no DOM porque ele pode ainda não estar no state
  const handleSimChange = (e) => {
    const emailInput = document.querySelector(`input[name="${names.email}"]`);
    const emailValue = emailInput ? emailInput.value : '';

    onCorrespondenciaChange(type, e.target.value, emailValue);
  };

  const handleNaoChange = (e) => {
    onCorrespondenciaChange(type, e.target.value, '');
  };

  return (
    <div>
      <label style={{
        fontWeight: 600,
        color: colors.darkBlue,
        fontSize: '0.9rem'
      }}>
        Recebe correspondência {type === 'comercial' ? 'comercial' : 'neste endereço'}?
        {type !== 'comercial' && <span style={{ color: '#ff4444' }}>*</span>}
      </label>

      <RadioGroup>
        <RadioLabel>
          <RadioInput
            type="radio"
            name={names.correspondencia}
            value="S"
            checked={values[names.correspondencia] === 'S'}
            onChange={handleSimChange}
            // Impede marcar "Sim" nos dois endereços ao mesmo tempo
            disabled={
              (type === 'comercial' && values.correspondenciaResidencial === 'S') ||
              (type === 'residencial' && values.correspondenciaComercial === 'S')
            }
          />
          Sim
        </RadioLabel>

        <RadioLabel>
          <RadioInput
            type="radio"
            name={names.correspondencia}
            value="N"
            checked={values[names.correspondencia] === 'N'}
            onChange={handleNaoChange}
          />
          Não
        </RadioLabel>
      </RadioGroup>

      {type === 'comercial' && values[names.correspondencia] === 'S' && (
        <small style={{
          color: '#d32f2f',
          display: 'block',
          marginTop: '5px',
          marginBottom: '10px',
          padding: '8px',
          backgroundColor: '#ffebee',
          borderRadius: '4px',
          border: '1px solid #ffcdd2',
          fontWeight: 500
        }}>
          ⚠️ <strong>Atenção:</strong> Ao marcar "Sim" para correspondência comercial,
          todos os campos do endereço comercial (CEP, logradouro, número, bairro,
          estado, município) passam a ser <strong>OBRIGATÓRIOS</strong>.
        </small>
      )}

      {type === 'comercial' && isResidencialCorrespondenceSelected && (
        <small style={{
          color: '#666',
          display: 'block',
          marginTop: '5px',
          fontStyle: 'italic'
        }}>
          ⚠️ Correspondência já será enviada para o endereço residencial
        </small>
      )}

      {type === 'residencial' && values.correspondenciaComercial === 'S' && (
        <small style={{
          color: '#666',
          display: 'block',
          marginTop: '5px',
          fontStyle: 'italic'
        }}>
          ⚠️ Correspondência já será enviada para o endereço comercial
        </small>
      )}
    </div>
  );
};
